export default __webpack_public_path__ + "static/updated_qr-545b7bd2be5e211c383b7d6c92db3b34.png";